
import style from './index.module.css';
import logo from '../../logo.png';
function Footer() {
    return (
        <footer className={style.footer}>
            <div className={style.inner}>
                <div className={style.brand}>
                    <div className={style.logoArea}>
                        <img src={logo} alt="logo" className={style.logo} />
                        <span className={style.logoText}>One・Achieve</span>
                    </div>
                    <p className={style.tagline}>株式会社 ワン・アチーブ</p>
                </div>
                <div className={style.links}>
                    <p className={style.linksTitle}>Legal</p>
                    <a className={style.App_link} href="https://k.secure.freee.co.jp/companies/1091523/announces" target="_blank" rel="noopener noreferrer">
                        電子公告
                    </a>
                </div>
            </div>
            <div className={style.bottom}>
                <p className={style.copyright}>
                    Copyright© 2023 株式会社One・Achieve. All Rights Reserved.
                </p>
            </div>
        </footer>
    );
}

export default Footer;